import docCookies from './docCookies';
import { Message } from 'element-ui';


const getDomain = () => {
  let domain = '';
  if (/localhost/.test(location.hostname)) {
    domain = 'localhost';
  } else {
    // eslint-disable-next-line no-useless-escape
    domain = location.hostname.replace(/(\w+\.)?(\w+\.\w+)(\:\d+)?$/i, '$2');
  }
  return domain;
}

// 根据Token判断是否登录
const isLogin = () => {
  let token = localStorage.getItem('token') || docCookies.getItem('token');
  return !!token;
}

// 设置登录用户的Token
const setToken = token => {
  if (token) {
    localStorage.setItem("token", token);
    let domain = getDomain();
    docCookies.setItem("token", token, Infinity, '/', domain);
  }
}

// 获取登录用户的Token
const getToken = () => {
  return localStorage.getItem("token") || docCookies.getItem("token");
};

// 移除Token
const removeToken = () => {
  localStorage.removeItem("token");
  let domain = getDomain();
  docCookies.removeItem("token", '/', domain);
};

// 当前页面是否运行在移动端设备浏览器中
const isMobile = () => {
  let regexp = /(phone|pad|pod|iPhone|iPad|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
  return regexp.test(window.navigator.userAgent);
}

// 当前页面是否运行在微信内置浏览器中
const isWXBrowser = () => /micromessenger/i.test(window.navigator.userAgent.toLowerCase());

// 获取本地购物车数据
const getCartInfo = () => {
  let cart = localStorage.getItem('cart') || { list: [], shipping: 0, subTotal: 0, amount: 0 };
  // 字符串转对象
  if (typeof cart === 'string') {
    cart = JSON.parse(cart);
  }
  return cart;
}

// 添加商品到本地购物车中
const addToCart = (params, callback) => {
  let { id, price, quantity } = params;
  if (!id || !price || isNaN(price) || !quantity || isNaN(quantity)) {
    console.warn(`addToCart: 参数不完整或参数错误({id: ${id}, price: ${price}, quantity: ${quantity}})`);
    return false;
  }
  // 
  let cart = getCartInfo();
  // 查找是否存在相同规格的商品
  let oldItem = cart.list.find(item => item.id == id);
  // 存在则更新数量，否则添加进本地存储
  if (oldItem) {
    // 原来的商品小计
    let oMoney = oldItem.quantity * oldItem.price;
    // 更新商品属性
    oldItem.price = price;
    oldItem.quantity = parseInt(oldItem.quantity) + parseInt(quantity);
    // 更新小计、合计
    let nMoney = oldItem.quantity * oldItem.price;
    cart.subTotal = cart.subTotal - oMoney + nMoney;
    cart.amount = cart.amount - oMoney + nMoney;
  } else {
    cart.list.push(params);
    // 更新小计、合计
    let nMoney = quantity * price;
    cart.subTotal += nMoney;
    cart.amount += nMoney;
  }
  // 更新本地存储
  localStorage.setItem('cart', JSON.stringify(cart));
  // 
  typeof callback == "function" && callback();
}

// 更新本地购物车中指定商品
const updateCart = (params, callback) => {
  let { oid, nid, price, quantity } = params;
  if (!oid || !nid || !price || isNaN(price) || !quantity || isNaN(quantity)) {
    console.warn(`updateCart: 参数不完整或参数错误({OldId: ${oid}, NewId: ${nid}, price: ${price}, quantity: ${quantity}})`);
    return false;
  }
  // 
  let cart = getCartInfo();
  //
  if (oid != nid) {
    // 查找要删除的记录条目
    let oItem = cart.list.find(item => item.id == oid);
    if (!oItem) return console.log(`updateCart: 原SKUID（${oid}）指定的条目不存在`), false;
    // 原来的商品小计
    let oPrice = String(oItem.price).replace(/(\$|￥)\s*/, '');
    let oMoney = parseFloat(oPrice) * parseInt(oItem.quantity);
    // 查找添加或修改(合并)的记录条目
    let nItem = cart.list.find(item => item.id == nid);
    if (nItem) {
      // 防止价格变更
      let nPrice = parseFloat(String(nItem.price).replace(/(\$|￥)\s*/, '')) * parseInt(nItem.quantity);
      // 更新商品属性
      nItem.price = price;
      nItem.quantity += quantity;
      // 更新小计、合计
      cart.subTotal = cart.subTotal - oMoney - nPrice + parseFloat(String(nItem.price).replace(/(\$|￥)\s*/, '')) * parseInt(nItem.quantity);
      cart.amount = cart.amount - oMoney - nPrice + parseFloat(String(nItem.price).replace(/(\$|￥)\s*/, '')) * parseInt(nItem.quantity);
    } else {
      let newArgs = Object.assign({}, params);
      newArgs.id = newArgs.nid;
      delete newArgs.oid;
      delete newArgs.nid;
      cart.list.push(newArgs);
      // 更新小计、合计
      let nMoney = parseFloat(String(newArgs.price).replace(/(\$|￥)\s*/, '')) * parseInt(newArgs.quantity);
      cart.subTotal = cart.subTotal - oMoney + nMoney;
      cart.amount = cart.amount - oMoney + nMoney;
    }
  } else {
    // 查找要修改的记录条目
    let oItem = cart.list.find(item => item.id == nid);
    if (!oItem) return console.warn(`localStorage中不存在 SKUID = ${nid} 的商品`), false;
    // 原来的商品小计
    let oPrice = String(oItem.price).replace(/(\$|￥)\s*/, '');
    let oMoney = parseFloat(oPrice) * parseInt(oItem.quantity);
    // 更新商品属性
    price && (oItem.price = price);
    quantity && (oItem.quantity = quantity);
    // 更新小计、合计
    let nPrice = String(oItem.price).replace(/(\$|￥)\s*/, '');
    cart.subTotal = cart.subTotal - oMoney + parseFloat(nPrice) * parseInt(oItem.quantity);
    cart.amount = cart.amount - oMoney + parseFloat(nPrice) * parseInt(oItem.quantity);
  }
  // 更新本地存储
  localStorage.setItem('cart', JSON.stringify(cart));
  //
  typeof callback == "function" && callback();
}

// 删除本地购物车中指定商品
const delCart = (id, callback) => {
  if (!id) return console.warn(`delCart: 参数不完整或参数错误({ID ${id}})`), false;
  // 
  let cart = getCartInfo();
  // 查找是否存在相同ID的商品
  let oIdx = cart.list.findIndex(item => item.id == id);
  if (oIdx != -1) {
    let oldItem = cart.list[oIdx];
    // 原来的商品小计
    oldItem.price = String(oldItem.price).replace(/(\$|￥)\s*/, '');
    let oldMoney = parseFloat(oldItem.price) * parseInt(oldItem.quantity);
    // 
    cart.list.splice(oIdx, 1);
    // 更新小计、合计
    cart.subTotal -= oldMoney;
    cart.amount -= oldMoney;
    // 更新本地存储
    localStorage.setItem('cart', JSON.stringify(cart));
    // 
    typeof callback == "function" && callback();
  } else {
    console.warn(`localStorage中不存在 SKU-ID = ${id} 的商品`);
  }
}

// 清空本地购物车中的商品
const clearCart = () => {
  // localStorage.setItem('cart', JSON.stringify([]));
  localStorage.removeItem('cart');
}
// 防抖
function debounce(handle, delay) {
  var timer = null;
  return function () {
      var _this = this, _arg = arguments;//谁调用此方法,this就指向谁
      clearTimeout(timer);
      timer = setTimeout(function () {
          handle.apply(_this, _arg);
      }, delay);
  }
}
// 节流
function throttle(handle, wait) {
  var lastTime = 0;
  return function () {
      //new Date().getTime()从1970到当前所过去的时间（毫秒）
      var nowTime = new Date().getTime();
      //时间差大于等于等待时间，就去执行函数
      if (nowTime - lastTime >= wait) {
          handle.apply(this, arguments);
          lastTime = nowTime;
      }
  }
}

// 页面信息设置：Title & SEO
const setPageInfo = (title, content) => {
  title && (document.title = title);
  let { keywords, description } = content || {};
  let headTag = document.querySelector("head");
  let keyTag = document.querySelector('meta[name="keywords"]');
  let descTag = document.querySelector('meta[name="description"]');
  if (keywords) {
    if (keyTag) {
      keyTag.setAttribute('content', keywords);
    } else {
      let meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = keywords;
      headTag.appendChild(meta);
    }
  } else if (keyTag) {
    if (keyTag.remove) {
      keyTag.remove();
    } else {
      keyTag?.parentElement?.removeChild?.(keyTag);
    }
  }
  if (description) {
    if (descTag) {
      descTag.setAttribute('content', description);
    } else {
      let meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      headTag.appendChild(meta);
    }
  } else if (descTag) {
    if (descTag.remove) {
      descTag.remove();
    } else {
      descTag?.parentElement?.removeChild?.(descTag);
    }
  }
};

// 日期格式化
const dateFormat = (date, fmt) => {
  if (date?.constructor != Date || fmt?.constructor != String) return "";
  var o = {   
    "M+" : date.getMonth()+1,                 //月份   
    "d+" : date.getDate(),                    //日   
    "h+" : date.getHours(),                   //小时   
    "m+" : date.getMinutes(),                 //分   
    "s+" : date.getSeconds(),                 //秒   
    "q+" : Math.floor((date.getMonth()+3)/3), //季度   
    "S"  : date.getMilliseconds()             //毫秒   
  };   
  if (/(y+)/i.test(fmt))   
    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
  for (var k in o)   
    if(new RegExp("("+ k +")").test(fmt))   
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  return fmt;   
}

// 是否展示原价
export const isShowOriginalPrice = (item, origin = 'original_price', price = 'price') => {
  if (!item) {
    return false;
  }

  const originValue = typeof item[origin] === 'number' ? item[origin] :
                      typeof item[origin] === 'string' ? parseFloat(item[origin].replace(/,/g, '')) :
                      undefined;

  const priceValue = typeof item[price] === 'number' ? item[price] :
                     typeof item[price] === 'string' ? parseFloat(item[price].replace(/,/g, '')) :
                     undefined;

  // 检查转换后的值是否为有效数字
  if (!isNaN(originValue) && !isNaN(priceValue)) {
    // 当 origin 大于 price 时返回 true
    return originValue > priceValue;
  }

  return false;
};

// eslint-disable-next-line no-misleading-character-class
export const regEmoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/ig;


/**
 * 是否包含港澳台
 * @param text 文本
 * @returns {Boolean}
 */
export const isTaiwanHKMacau = (text) => {
  return /台湾|香港|澳门/.test(text);
}

/**
 * 获取收钱吧支付方式
 * @returns {Number} 返回收钱吧支付方式
 */
// export const getSqbPaymentMethod = () => {
//   return isMobile() ? SQB_PAY_TYPES.H5_SQB_PAY : SQB_PAY_TYPES.PC_SQB_PAY;
// }

export const copyText = (value) => {
  if (isMobile()) {
    // 创建一个临时的textarea元素
    const textarea = document.createElement('textarea');
    textarea.value = value;
    // 将textarea元素添加到DOM中
    document.body.appendChild(textarea);
    // 选中文本
    textarea.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除临时的textarea元素
    document.body.removeChild(textarea);
    Message({ message: '复制成功', type: "success" });
  } else {
    // 复制文本到剪贴板的逻辑，可以使用相应的库或者原生API
    const textToCopy = typeof value === 'string' ? value : value.toString();
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        Message({ message: '复制成功', type: "success" });
      })
      .catch(() => {
        Message({ message: '复制成功', type: "warning" });
      });
  }
}
export const formatSensitiveInfo = (type, value) => {
  const starCount = value.length - 1 > 2 ? 2 : value.length - 1;

  switch (type) {
    case 'name':
      // 姓名只显示第一个字，其余用*代替
      if (!value) return '';
      return value.charAt(0) + '*'.repeat(starCount > 0 ? starCount : 0);


    case 'mobile':
      // 手机号码隐藏中间四位
      if (!value) return '';
      return value.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');

    case 'address':
      // 地址详情用*代替
      return '******';

    default:
      return '******';
  }
}

// 根据条目计算总数
export const calcQuantity = (list) => {
  return list?.length ? list.reduce((prev, curr) => prev + curr.quantity, 0) : 0
}

// 筛选ram商品
export const filterRamGoods = (data) => {
  const { goods = [] } = data;
  if (goods.length === 0) return []
  return goods.filter(item => item.is_rma === 1);
}
// 判断是否过期（超过14天）
export const isExpired = (timestamp, time = 14) => {
  if (!timestamp) return true;

  // 如果 time == 0，判断是否为同一天
  if (time === 0) {
    const recordDate = new Date(timestamp);
    const currentDate = new Date();

    // 比较年、月、日是否相同
    return recordDate.getFullYear() !== currentDate.getFullYear() ||
      recordDate.getMonth() !== currentDate.getMonth() ||
      recordDate.getDate() !== currentDate.getDate();
  } else {
    // 原有的按天数计算逻辑（用于14天的场景）
    const daysInMs = time * 24 * 60 * 60 * 1000;
    const currentTime = new Date().getTime();
    return (currentTime - timestamp) > daysInMs;
  }
}

// 仅购物车页面使用
export const checkAndShowCookiePolicy = () => {
  const cookieAccept = JSON.parse(localStorage.getItem('cookieAccept')) || {};
  const privacyAccept = JSON.parse(localStorage.getItem('privacyAccept')) || {};

  const isCookieExpired = !cookieAccept.accept || isExpired(cookieAccept.timestamp);
  const isPrivacyExpired = !privacyAccept.accept || isExpired(privacyAccept.timestamp);

  // 清除缓存
  if (!cookieAccept.accept || isCookieExpired) {
    localStorage.removeItem('cookieAccept');
  }

  if (!privacyAccept.accept || isPrivacyExpired) {
    localStorage.removeItem('privacyAccept');
  }

// 如果任一政策需要重新确认，则显示弹窗
  return isCookieExpired || isPrivacyExpired;
}

// 设置页面title
export const setPageTitle = (name) => {
  if (name) {
    const title = name;
    document.title = `${title} - Onitsuka Tiger`;
  } else {
    document.title = 'Onitsuka Tiger 鬼塚虎中国官方网站';
  }
}


export default {
  isLogin,
  setToken,
  getToken,
  removeToken,
  isMobile,
  isWXBrowser,
  getCartInfo,
  addToCart,
  updateCart,
  delCart,
  clearCart,
  debounce,
  throttle,
  setPageInfo,
  dateFormat,
  isShowOriginalPrice,
  regEmoji,
  isTaiwanHKMacau,
  // getSqbPaymentMethod,
  copyText,
  formatSensitiveInfo,
  calcQuantity,
  filterRamGoods,
  isExpired,
  checkAndShowCookiePolicy,
  setPageTitle
};